// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_styles_root__F4Z2C {
  margin-bottom: var(--padding-medium);
}

.storage_styles_titleBlock__ggDIW {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  gap: 16px;
}

.storage_styles_subtitleBlock__rqyeg {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 767px) {
  .storage_styles_titleBlock__ggDIW {
    display: block;
  }

  .storage_styles_subtitleBlock__rqyeg {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
}

.storage_styles_contractDropdown__NCrbG {
  min-width: 298px !important;
}
`, "",{"version":3,"sources":["webpack://./src/containers/PageHeader/styles.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;AACF;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".root {\n  margin-bottom: var(--padding-medium);\n}\n\n.titleBlock {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 16px;\n  gap: 16px;\n}\n\n.subtitleBlock {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n@media (max-width: 767px) {\n  .titleBlock {\n    display: block;\n  }\n\n  .subtitleBlock {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n}\n\n.contractDropdown {\n  min-width: 298px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `storage_styles_root__F4Z2C`,
	"titleBlock": `storage_styles_titleBlock__ggDIW`,
	"subtitleBlock": `storage_styles_subtitleBlock__rqyeg`,
	"contractDropdown": `storage_styles_contractDropdown__NCrbG`
};
export default ___CSS_LOADER_EXPORT___;
